import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from 'recharts'

const COLORS = ['#2D6A4F', '#6366f1', '#a855f7', '#f59e0b', '#ef4444', '#06b6d4']

export default function AgentDistributionChart({ agents }) {
  if (!agents || agents.length === 0) {
    return (
      <div className="bg-white rounded-xl border border-slate-200 p-6 h-full">
        <h3 className="text-sm font-semibold text-slate-900 mb-4">Agent Distribution</h3>
        <div className="flex items-center justify-center h-32 text-sm text-slate-400">
          No data yet
        </div>
      </div>
    )
  }

  const data = agents.map((a) => ({ name: a.name, value: a.count }))

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-6 h-full">
      <h3 className="text-sm font-semibold text-slate-900 mb-4">Agent Distribution</h3>
      <ResponsiveContainer width="100%" height={220}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={50}
            outerRadius={80}
            paddingAngle={3}
            dataKey="value"
          >
            {data.map((_, i) => (
              <Cell key={i} fill={COLORS[i % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip
            contentStyle={{ borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 12 }}
            formatter={(value, name) => [`${value} conversations`, name]}
          />
          <Legend wrapperStyle={{ fontSize: 11 }} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  )
}
